import { convertBase64ToExcelBlob } from '@/appLogic/blobEncoder';
import { OutputOrderResponseResult } from '@/coreInfrastructureModule/axios/generated/orderManage/api';
import { OutputOrderData, OutputOrderExcelData } from '../domains/entities/orderResponse';
import { UserAccountFactory } from '@/coreDomainsModule/factories/userAccountFactory';

/**
 * 発注エクセルテンプレートとエクセルに書き込む情報を取得するアダプタ
 */
export class GetOutputOrderExcelDataAdapter {
  /**
   * responseをUI用に変換する
   * @param response - レスポンス
   */
  public static async adaptForResponse(response: OutputOrderResponseResult): Promise<OutputOrderExcelData> {
    try {
      // 発注エクセルテンプレート
      const excelFile = response.data.excelFile;
      if (!excelFile) {
        throw new Error('テンプレートファイルが取得できませんでした');
      }
      const blob = await convertBase64ToExcelBlob(excelFile);

      const excelInputInfo: OutputOrderData[] = [];

      response.data.outputOrderList.forEach((order) => {
        excelInputInfo.push({
          orderId: order.orderId,
          createdOrderDate: order.createdOrderDate ?? undefined,
          orderAmount: order.orderAmount,
          desiredDeliveryDate: order.desiredDeliveryDate,
          estimatedTimeOfArrival: order.estimatedTimeOfArrival,
          warehouseNumber: order.warehouseNumber,
          warehouse: order.warehouse,
          supplierNumber: order.supplierNumber,
          supplierName: order.supplierName,
          manufacturer: order.manufacturer,
          businessNumber: order.businessNumber,
          businessName: order.businessName,
          package: order.package,
          unit: order.unit ?? undefined,
          orderIssuedNumber: order.orderIssuedNumber,
          orderNumber: order.orderNumber ?? undefined,
          aggregateBusinessResponsibleUsers:
            order.aggregateBusinessResponsibleUsers?.map((user) => UserAccountFactory.create({ email: user.id, name: user.name })) ?? [],
          orderNote: order.orderNote ?? '',
          orderGroupName: order.orderGroupName ?? undefined,
          invoiceNumber: order.invoiceNumber ?? undefined,
          destinationName: order.destinationName ?? undefined,
          userCustomParameters: order.userCustomParameters ? order.userCustomParameters : {},
        });
      });

      return {
        templateOrderExcelData: blob,
        excelInputInfo: excelInputInfo,
      };
    } catch (error) {
      throw new Error('Base64からExcelファイルの変換に失敗しました');
    }
  }
}
